module.exports = __webpack_public_path__ + "static/img/xiaofang_anquan.396c297f.png";